import React from 'react';
import { graphql } from 'react-apollo';
import { Tooltip } from 'react-tippy';
import TOGGLE_THEATER_MUTATION from '../../../../graphql/ToggleTheater';

class ToggleTheater extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      status: props.status,
    };
  }

  toggleTheater = () => {
    const { mutate, id } = this.props;
    mutate({
      variables: {
        id,
      },
    })
      .then((res) => {
        this.setState({ status: !this.state.status });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  render() {
    return (
      <Tooltip
        title={this.state.status ? 'Desactivar' : 'Activar'}
        position="bottom"
        trigger="mouseenter"
        followCursior
      >
        <button
          onClick={e => this.toggleTheater(e.target)}
          className={`btn btn-adm ${this.state.status ? 'btn-danger' : 'btn-success'}`}
        >
          <i className={`fa ${this.state.status ? 'fa-ban' : 'fa-check'}`} aria-hidden="true" />
        </button>
      </Tooltip>
    );
  }
}
const withMutation = graphql(TOGGLE_THEATER_MUTATION);

export default withMutation(ToggleTheater);



// WEBPACK FOOTER //
// ./src/containers/Admin/Theater/Toggle/index.js